module.exports = __webpack_public_path__ + "img/ClownofPrizes.914621bb.png";